module.exports = __webpack_public_path__ + "img/sepa.a18e114.svg";